// extracted by mini-css-extract-plugin
module.exports = {"treeNode":"articleTree_treeNode__2pYOK"};